export default "__VITE_ASSET__BXodCuOI__"